import { Link } from 'react-router-dom';
import { useWhatsNew } from '../hooks/useWhatsNew';

/**
 * Link to the What's New page with an unread count badge.
 * Displays on the home page alongside the welcome message.
 */
export function WhatsNewLink() {
  const { undismissedAnnouncements, allAnnouncements, isLoading } = useWhatsNew();
  const unreadCount = undismissedAnnouncements.length;

  // Don't show if no announcements at all
  if (isLoading || allAnnouncements.length === 0) {
    return null;
  }

  return (
    <Link
      to="/whats-new"
      className="group relative flex items-center gap-3 overflow-hidden rounded-xl border border-lime/20 bg-gradient-to-r from-lime/5 via-lime/10 to-lime/5 px-5 py-2.5 shadow-lg shadow-lime/5 transition-all hover:border-lime/40 hover:shadow-lime/10"
    >
      {/* Animated background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-transparent via-lime/5 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />

      {/* Lightning bolt icon */}
      <svg
        className="h-5 w-5 text-lime transition-transform group-hover:scale-110"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 10V3L4 14h7v7l9-11h-7z"
        />
      </svg>

      <span className="text-sm font-bold text-white transition-colors group-hover:text-lime">
        What's New
      </span>

      {unreadCount > 0 && (
        <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-lime px-2 text-xs font-bold text-black shadow-[0_0_10px_rgba(209,245,81,0.5)]">
          {unreadCount}
        </span>
      )}
    </Link>
  );
}
